import Dispatcher from 'flux/lib/Dispatcher';
import objectAssign from 'object-assign';

const dispatcher = objectAssign(new Dispatcher(), {
	handleAction(action) {
		this.dispatch({
			source: 'VIEW_ACTION',
			action
		})
	}
});

export default dispatcher;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/dispatcher.js